import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import {
  Actions,
  Input,
  MonthActions
} from "@website/ui/datepicker/components";
import styles from "@website/ui/datepicker/components/header/header.module.scss";
import { HeaderPropertiesType } from "@website/ui/datepicker/components/header/header.types";
import { WEEK_ABBR } from "@website/ui/datepicker/constanst";
import { TopAppBar } from "@website/ui/top-app-bar";
import { FC, memo } from "react";

const Header: FC<HeaderPropertiesType> = (properties) => {
  const {
    calendarLocale = "gregorian",
    showDates,
    inputProperties,
    scrolled,
    onClose,
    showToday,
    changeCalendarLocale,
    showPreviousMonth,
    showNextMonth,
    nextMonthDisabled,
    previousMonthDisabled,
    type,
    view,
    backButton
  } = properties;

  return (
    <div
      className={`${styles["header"]} ${styles["rtl" || "ltr"]} ${
        scrolled ? styles["scrolled"] : ""
      }`}
    >
      {!scrolled && (
        <div className={styles["top-app-bar"]}>
          <TopAppBar
            StartAction={
              <Button
                EndIcon={
                  <MaterialIcon name="arrow_forward" variant="outlined" />
                }
                color="neutral"
                equalDimension
                onClick={() => {
                  onClose();
                  backButton?.();
                }}
                variant="text"
              />
            }
            title="انتخاب تاریخ"
          />
        </div>
      )}
      <div className={styles["part-one"]}>
        {!scrolled && (
          <Actions
            calendarLocale={calendarLocale}
            changeCalendarLocale={changeCalendarLocale}
            showToday={showToday}
          />
        )}
        <div className={styles["input-container"]}>
          <Input {...inputProperties} disabled fullWidth />
        </div>
      </div>
      <MonthActions
        calendarLocale={calendarLocale}
        nextMonthDisabled={nextMonthDisabled}
        previousMonthDisabled={previousMonthDisabled}
        showDates={showDates}
        showNextMonth={showNextMonth}
        showPreviousMonth={showPreviousMonth}
        type={type}
      />
      <div
        className={`${styles["week-names-container-mobile"]} ${
          view === "mobile"
            ? ""
            : styles["week-names-container-mobile__default"]
        }`}
      >
        {[1, 2, 3, 4, 5, 6, 7].map((item) => (
          <div className={styles["week-name"]} key={item}>
            {WEEK_ABBR[calendarLocale]?.[item - 1] ||
              WEEK_ABBR.gregorian[item - 1]}
          </div>
        ))}
      </div>
    </div>
  );
};

const HeaderMemoized = memo(Header);
export { HeaderMemoized as Header };
